/**
 * Free sample checkbox (cart drawer + cart page)
 *
 * The checkbox and its state are rendered in Liquid by
 * snippets/free-sample-offer.liquid, so they survive the innerHTML re-render
 * of the drawer and the cart page. This script only:
 *
 * 1. Adds / removes the sample when the checkbox is ticked / unticked, then
 *    re-renders the cart the same way the theme does (section rendering).
 * 2. Watches the cart for the data-fix attribute the snippet prints and
 *    corrects the cart: removes the sample when nothing else is left, and
 *    brings it back to 1 when there is more than one.
 *
 * It never touches the checkout button (no disabled, no classes, no styles).
 */
(function () {
  if (window.__freeSampleInit) return;
  window.__freeSampleInit = true;

  var BOX_SELECTOR = '[data-free-sample]';
  var TOGGLE_SELECTOR = '[data-free-sample-toggle]';
  var ERROR_SELECTOR = '[data-free-sample-error]';
  var BUSY_CLASS = 'free-sample-busy';
  var CHECK_DELAY = 200;
  var MAX_AUTO_FIXES = 3;

  var busy = false;
  var pending = false;
  var autoFixes = 0;
  var timer = null;

  // Locale-aware root, e.g. "/en-qa/" or "/ar-qa/".
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sectionIds() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    var main = document.getElementById('main-cart-items');
    if (main && main.dataset.id) ids.push(main.dataset.id);
    return ids;
  }

  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function swap(html, sourceSelector, target) {
    if (!html || !target) return;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
    if (source) target.innerHTML = source.innerHTML;
  }

  // Same replacements the theme does after a quantity change.
  function render(sections, isEmpty) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      swap(sections['cart-drawer'], '#CartDrawer .drawer__inner', drawer.querySelector('.drawer__inner'));
      drawer.classList.toggle('is-empty', isEmpty);
    }

    var main = document.getElementById('main-cart-items');
    if (main) {
      swap(sections[main.dataset.id], '.js-contents', main.querySelector('.js-contents'));
      main.classList.toggle('is-empty', isEmpty);
    }

    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', isEmpty);

    swap(sections['cart-icon-bubble'], '.shopify-section', document.getElementById('cart-icon-bubble'));
  }

  // quantity: 'add' to add one sample, or a number to set its quantity (0 removes it).
  function setSample(variantId, quantity) {
    busy = true;
    document.documentElement.classList.add(BUSY_CLASS);

    var body = {
      sections: sectionIds().join(','),
      sections_url: window.location.pathname
    };
    var request;

    if (quantity === 'add') {
      body.items = [{ id: Number(variantId), quantity: 1 }];
      request = post('cart/add.js', body);
    } else {
      body.updates = {};
      body.updates[variantId] = quantity;
      request = post('cart/update.js', body);
    }

    return request
      .then(function (data) {
        var isEmpty = quantity === 'add' ? false : data.item_count === 0;
        render(data.sections || {}, isEmpty);
      })
      .finally(function () {
        busy = false;
        document.documentElement.classList.remove(BUSY_CLASS);
        if (pending) {
          pending = false;
          schedule();
        }
      });
  }

  // Checkbox ticked / unticked. Delegated, so it keeps working after re-renders.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches(TOGGLE_SELECTOR)) return;

    var box = input.closest(BOX_SELECTOR);
    if (!box) return;

    var wanted = input.checked;
    if (busy) {
      input.checked = !wanted;
      return;
    }

    setSample(box.dataset.variantId, wanted ? 'add' : 0).catch(function (err) {
      console.error('[free-sample]', err);
      // Nothing was re-rendered, so put the checkbox back and show a message.
      input.checked = !wanted;
      var msg = box.querySelector(ERROR_SELECTOR);
      if (msg) {
        msg.textContent = box.dataset.error || '';
        msg.hidden = false;
      }
    });
  });

  // Reads the state Liquid printed and corrects the cart when needed.
  function check() {
    if (busy) {
      pending = true;
      return;
    }

    var box = document.querySelector(
      BOX_SELECTOR + '[data-fix="remove"], ' + BOX_SELECTOR + '[data-fix="reduce"]'
    );

    if (!box) {
      autoFixes = 0;
      return;
    }

    // Safety stop so a failing correction can never loop.
    if (autoFixes >= MAX_AUTO_FIXES) return;
    autoFixes += 1;

    setSample(box.dataset.variantId, box.dataset.fix === 'remove' ? 0 : 1).catch(function (err) {
      console.error('[free-sample]', err);
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, CHECK_DELAY);
  }

  // The drawer and cart page are re-rendered inside these elements.
  var observer = new MutationObserver(schedule);
  ['cart-drawer', '#main-cart-items'].forEach(function (selector) {
    var el = document.querySelector(selector);
    if (el) observer.observe(el, { childList: true, subtree: true });
  });

  check();
})();